import photo from '../../assets/images/photos_stub.png';
import {
	StyledContainer,
	StyledGrid,
	StyledPhotoItem,
	StyledPhotoItemWrapper,
	StyledTitle,
} from './AppPhotosGrid.styled';

const AppPhotosGrid = ({
	setIsPhoto,
}: {
	setIsPhoto: (isPhoto: boolean) => void;
}) => {
	return (
		<StyledContainer>
			<StyledTitle>Фото</StyledTitle>
			<StyledGrid>
				{new Array(20).fill(0).map((_, index) => (
					<StyledPhotoItemWrapper key={index} onClick={() => setIsPhoto(true)}>
						<StyledPhotoItem src={photo} />
					</StyledPhotoItemWrapper>
				))}
			</StyledGrid>
		</StyledContainer>
	);
};

export { AppPhotosGrid };
